import axios from '@/plugins/axios'

export default {
    getStoreSpeed(){
        return axios({
            url: '/store/speed-summary',
            method: 'get'
        })
    },
    getSpeedSummaryResync() {
        return axios({
            url: '/store/speed-summary-resync',
            method: 'get'
        })
    },
    getCheckSyncSpeedSummary() {
        return axios({
            url: '/store/sync-speed-summary',
            method: 'get'
        })
    }
}